import { render } from "./itihas-page.vue?vue&type=template&id=785ee658&scoped=true"
import script from "./itihas-page.vue?vue&type=script&lang=js"
export * from "./itihas-page.vue?vue&type=script&lang=js"

import "./itihas-page.vue?vue&type=style&index=0&id=785ee658&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785ee658"]])

export default __exports__